import { useMemo } from "preact/hooks";
import { getQueueTrackPlayable } from "services/player/inputs/inputs/playQueue/helpers";
import type { QueueTrackModel } from "models/app/player/input";
import type { TrackPlayablePreviewModel } from "models/domain/TrackPlayableModel";

export function useQueueTrackPlayableFromState(queueTrack: QueueTrackModel | null): TrackPlayablePreviewModel | null {
    const track = useMemo(() => (queueTrack ? getQueueTrackPlayable(queueTrack) : null), [queueTrack]);
    return track;
}
